import {
  JsonapiEntity,
  OneUnresolvedIdentifierOr,
  ResourceIdentifier,
  entity,
  relationship,
} from 'jsonapi-transformers';

import { RoleRecord } from './role-record';
import { UserRecord } from './user-record';

@entity({ type: 'user_constraints' })
export class UserConstraint extends JsonapiEntity<UserConstraint> {
  @relationship({ allowUnresolvedIdentifiers: true })
  user: OneUnresolvedIdentifierOr<UserRecord>;
  @relationship({ allowUnresolvedIdentifiers: true })
  role: OneUnresolvedIdentifierOr<RoleRecord>;
  @relationship({ allowUnresolvedIdentifiers: true })
  applies_to: OneUnresolvedIdentifierOr<ResourceIdentifier>;
}
